<script setup lang="ts">
const props = withDefaults(defineProps<{
  percentageFilled?: number
  size?: 'small' | 'medium' | 'large'
}>(), {
  percentageFilled: 100,
  size: 'small',
})

const iconSizes = {
  small: '16px',
  medium: '24px',
  large: '27px',
} as const

const iconSizeInPixels = computed((): string => iconSizes[props.size])

</script>

<template>
  <span class="rating-star">
    <Icon
      v-if="percentageFilled < 100"
      name="fa6-solid:star"
      class="rating-star__icon --empty"
      :size="iconSizes[size]"
    />

    <template v-if="percentageFilled > 0">
      <Icon
        v-if="percentageFilled === 100"
        name="fa6-solid:star"
        class="rating-star__icon --filled"
        :size="iconSizes[size]"
      />
      <span
        v-else
        class="rating-star__icon-container"
        :style="`width:${percentageFilled}%;`"
      >
        <Icon
          name="fa6-solid:star"
          class="rating-star__icon --filled"
          :size="iconSizes[size]"
        />
      </span>
    </template>
  </span>
</template>

<style lang="scss" scoped>
.rating-star {
  position: relative;
  display: inline-flex;
  width: v-bind('iconSizeInPixels');
  height: v-bind('iconSizeInPixels');
}

.rating-star__icon-container {
  position: absolute;
  display: grid;
  overflow: hidden;
}

.rating-star__icon {
  vertical-align: text-top;

  &.--empty {
    color: var(--app-color-rating-empty);
    position: relative;
  }

  &.--filled {
    color: var(--app-color-rating-filled);
  }
}
</style>
